
import { IntertextShort } from '@/interfaces/IntertextShort';
import { defineComponent, PropType } from 'vue';

export default defineComponent({ props: { intertext: Object as PropType<IntertextShort> } });
